import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Divider, Button, Icon, Popconfirm, Row, Col, Radio, message, Input} from 'antd';
import axios from 'axios';
import LeaveRequestDialogForm from './LeaveRequestForm'
import Moment from 'react-moment';
import moment from 'moment';
import Highlighter from 'react-highlight-words';

const API_HOST_URL = process.env.REACT_APP_API_URL

class LeaveRequestsForApproval extends Component{
  
  state = {
    datalist: [],
    filteredDataList: [],
    leaveRequest: {},
    visible: false,
    requestType: '',
    requestBeingApproved: 0,
    requestBeingDenied: 0,
    searchText: ''
  }

  componentDidMount(){
    this.fetchData();
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].firstName.toString().toLowerCase().includes(value.toLowerCase()) ||
    record[dataIndex].lastName.toString().toLowerCase().includes(value.toLowerCase()), 
    
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }

  columns = [
    {
      title: 'Employee',
      dataIndex: 'employee',
      key: 'employee',
      ...this.getColumnSearchProps('employee'),
      render: (record) => (
        <a>{(record !== null)? record.firstName + ' ' + record.lastName: ''}</a>
      )
    },
    {
      title: 'Leave Type',
      dataIndex: 'leaveType.leaveType',
      key: 'leaveType'
    },
    {
      title: 'From',
      dataIndex: 'fromDate',
      key: 'fromDate',
      render: (record) => (
        moment(record).format('ll')
      )
      
    },
    {
      title: 'To',
      dataIndex: 'toDate',
      key: 'toDate',
      render: (record) => (
        moment(record).format('ll')
      )
    },
    {
      title: 'Day(s)',
      // dataIndex: 'amount',
      key: 'amount',
      render: (record) => (
        <span>
          {
            record.amount + (record.amount>1? ' days':' day')
              // this.leaveDuration(record.amount)
          }
        </span>   
      )
    },
    {
      title: 'Reason',
      dataIndex: 'note',
      key: 'note'
    },
    
    {
      title: 'Status',
      // dataIndex: 'action',
      key: 'status',
      render: (record) => (
            <span style={{color: record.status === 'Approved' && record.status!=='Pending'? 'green': (record.status === 'Denied'?'red':'black') }}>
              {record.status}
            </span>
      )
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (record) => (
        <span>
          { record.status !== 'Approved'?
            <Button loading={this.state.requestBeingApproved == record.id} type="primary" size="small" onClick={() => this.approveLeaveRequest(record)}>
            {/* <Icon type="check-circle" style={{color: 'green'}} /> */}
            Approve</Button>
            :
            ''
          }
          <Divider type="vertical" />
          { record.status !== 'Denied'?
            <Button loading={this.state.requestBeingDenied == record.id} type="danger" size="small" onClick={() => this.denyLeaveRequest(record)}>
            {/* <Icon type="close-circle" style={{color: 'red'}} /> */}
            Deny</Button>   
           :
           ''
           }
          </span>
      ),

    }
  ];

  leaveDuration(hours){
    let days = 0;
    let eightHourDay_hours = 0;
    let extraHours = 0;
    if(hours >= 8 ){
      console.log("Postive hours "+ hours);
      eightHourDay_hours = (8 * hours)/24;
      days = Math.trunc(eightHourDay_hours/8);
      extraHours = Math.trunc(eightHourDay_hours % 8)
      return days + (days>1?' days':' day') + ', ' + extraHours  + (extraHours>1?' hours':' hour')
    } else {
      extraHours = hours;
      return extraHours + (extraHours>1?' hours':' hour')
    } 
  }

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/leave/leaverequest/?expand=employee&expand=leaveType&approver=${this.props.loggedInEmployee.id}`)
      .then(res => {
        this.setState({
          datalist: res.data,
          filteredDataList: res.data.filter((item) => item.status === 'Pending')
      })
      console.log(res.data)
  })
}

  filterData = (status) => {
    let filteredLeaveRequests = this.state.datalist
    filteredLeaveRequests = filteredLeaveRequests.filter((item) => {
      return item.status === status && status!=='All'
      }
    )
    this.setState({
      filteredDataList: filteredLeaveRequests
    })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      console.log("Employee Id: ", this.props.loggedInEmployee.id)
      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/leave/leaverequest/`, {
              fromDate: values.fromDate,
              toDate: values.toDate,
              amount: values.amount,
              note: values.note,
              leaveType: values.leaveType,
              employee: this.props.loggedInEmployee.id
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false });
              this.fetchData()
        })
            .catch(error => console.err(error));

        case 'put':
            return axios.put(`${API_HOST_URL}/api/leave/leaverequest/${this.state.leaveRequest.id}/`, {
              fromDate: values.fromDate,
              toDate: values.toDate,
              amount: values.amount,
              note: values.note,
              leaveType: values.leaveType,
              employee: this.props.loggedInEmployee.id
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
                
        default: return;
      }
    });
  }

  update =(leaveRequestId, approvalStatus) =>{
    axios.patch(`${API_HOST_URL}/api/leave/leaverequest/${leaveRequestId}/`, {
              status: approvalStatus
            })
                .then(res => {
                  console.log(res)
                  this.setState({ visible: false });
                  this.fetchData()
                  if(res.data.status == 'Approved'){
                    message.success('Leave Approved.');
                  } else if(res.data.status == 'Denied') {
                    message.warning('Leave Denied.');
                  }
            })
                .catch(error =>{
                  message.error('Leave not ' + approvalStatus + '. A problem Occured!');
                });
  }

  approveLeaveRequest = record => {
    console.log(record);
    const requestToApprove = record;
    this.setState({
        requestBeingApproved: requestToApprove.id
    }, this.update(record.id, 'Approved')
  )
  console.log(this.state.approvingInProgress, this.state.requestBeingApproved)
    
  }

  denyLeaveRequest = (record) => {
    console.log('Deny');
    this.setState({
      requestBeingDenied: record.id
  }, this.update(record.id, 'Denied'))
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({leaveRequest: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            <Row>
              <Col span={8}>
                {/* <h2>Leave Requests For My Approval</h2> */}
              </Col>
              <Col span={8} offset={8}>
                <Radio.Group defaultValue="Pending" buttonStyle="solid" onChange={(event)=>this.filterData(event.target.value)}>
                  <Radio.Button value="Pending">Pending</Radio.Button>
                  <Radio.Button value="Approved">Approved</Radio.Button>
                  <Radio.Button value="Denied">Denied</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            
            
            <Table columns={this.columns} dataSource={this.state.filteredDataList} rowKey="id" scroll={{ x: '100%' }}/>

            <LeaveRequestDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.leaveRequest}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    loggedInEmployee: state.loggedInEmployee
  }
}

export default connect(mapStateToProps, null)(LeaveRequestsForApproval);
